export function highlightSearchTerms() {
    const searchParams = new URLSearchParams(window.location.search)
    let searchTerms = searchParams.get('search')

    if (searchTerms) {
        searchTerms = escapeRegExp(searchTerms)
        let element
        const pageElement = document.getElementsByClassName('page')

        if (pageElement.length > 0) {
            element = pageElement.item(0)
        } else {
            const postElement = document.getElementsByClassName('post')

            if (postElement.length > 0) {
                element = postElement.item(0)
            }
        }

        if (element) {
            const re = new RegExp('(' + searchTerms + ')', 'gi')

            const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT)

            const elements: Element[] = []
            let node

            while ((node = walker.nextNode())) {
                elements.push(node.parentElement)
            }

            for (const elt of elements) {
                elt.innerHTML = elt.innerHTML.replace(re, `<mark>$1</mark>`)
            }
        }
    }
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}
